import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["active", "onClick", "disabled", "children"];
import React from 'react';
import classNames from 'classnames/bind';
import { ButtonBase } from "../../internal/ButtonBase";
import styles from '../PageNavigator.css';
var cx = classNames.bind(styles);
export var Button = function Button(_ref) {
  var active = _ref.active,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ButtonBase, _extends({}, restProps, {
    onClick: onClick,
    className: cx('button', {
      disabled: disabled,
      active: active
    })
  }), children);
};